<template>
  <div>
    <ValidationProvider ref="tutorEmail" v-slot="{ errors }" name="email" rules="required|email" mode="passive">
      <div class="st-top-banner-input" :class="{flat}">
        <input
          v-model.trim="email"
          type="text"
          :class="{flat}"
          class="lg:w-2/3 w-full ml-2 text__caption-1-xs--regular lg:text__title-input-md--regular"
          :placeholder="$t('common.placeholders.email') + '...'"
          @keyup.enter="submit"
        >
        <BaseButton
          shadow
          :size="flat ? 'lg': 'sm'"
          label="Become a tutor"
          class="w-1/3 hidden lg:flex"
          :loading="loading"
          @click="submit"
        />
      </div>
      <div class="lg:flex items-center space-x-4 mt-4">
        <BaseButton
          shadow
          :size="flat ? 'lg': 'sm'"
          label="Become a tutor"
          class="w-full flex lg:hidden"
          :loading="loading"
          @click="submit"
        />
        <p class="text-error mt-2 ml-2 min-h-[24px] text-body-3-caption">
          {{ errors[0] | UFirstLetter }}
        </p>
      </div>
    </ValidationProvider>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'CommonEmailInputButton',
  props: {
    flat: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      email: '',
      loading: false
    }
  },
  methods: {
    ...mapActions('local', ['emailRegistration']),
    async submit () {
      const res = await this.$refs.tutorEmail.validate()
      if (res.valid) {
        this.loading = true
        try {
          const data = await this.emailRegistration({ email: this.email })
          if (data?.email) {
            this.$router.push(this.localePath({
              name: this.$routes.start_teaching_email_registered.name,
              query: { email: this.email }
            })
            )
          }
        } catch (e) {
        } finally {
          this.loading = false
        }
      } else {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
.st-top-banner-input {
  @apply bg-white shadow-cart-resting-xs p-2 w-full rounded-lg flex space-x-3 items-center h-12 lg:h-14;
  input {
    @apply border-white outline-0;
    &.flat{
        @apply border border-border-text-field rounded-lg px-3 py-2 ml-0 h-12;
    }
    :focus {
      @apply border-none outline-0;
    }
  }
  &.flat {
      @apply shadow-none p-0;
  }
}
input:focus {
  outline: none;
}
</style>
